import React from "react";
import img1 from "../../assets/img/136048.png";
import "./bigfix.css"; // Assuming you create a CSS file alongside it

export const Summary = () => {
  return (
    <section className="summary-section">
      <div className="summary-container">
        {/* Image Side */}
        <div className="summary-image-wrapper">
          <img src={img1} alt="BigFix Interface illustration" className="summary-image" />
        </div>

        {/* Content Side */}
        <div className="summary-content">
          <h2 className="summary-title">What is BigFix?</h2>
          <p className="summary-description">
            BigFix is an endpoint management platform that enables organizations
            to efficiently manage and secure endpoints across their network. It
            provides <strong>real-time visibility</strong>, <strong>patch management</strong>, 
            <strong> security compliance</strong>, and <strong>automated remediation</strong>.
          </p>
          <p className="summary-description">
            This allows IT teams to control and optimize endpoint configurations, 
            ensuring a secure and compliant computing environment from a single console.
          </p>
        </div>
      </div>
    </section>
  );
};